import { render, staticRenderFns } from "./PiggySettings.vue?vue&type=template&id=741c5877"
import script from "./PiggySettings.vue?vue&type=script&lang=js"
export * from "./PiggySettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports